/**
 * Ubicación de la butaca de un abonado, en un solo formato: `Tribuna · Fila 12,
 * Butaca 5`.
 *
 * El nivel va SIEMPRE delante y no es opcional: la fila y el número de butaca se
 * repiten en cada nivel del recinto, así que «Fila 12, Butaca 5» a secas no
 * identifica ningún sitio. Por eso esto es una función compartida y no un getter
 * por pantalla: había cuatro copias del texto —«mis abonos», el carnet digital,
 * la ficha del abonado en el panel y el detalle del pedido de abono— y ninguna
 * de las cuatro ponía el nivel.
 *
 * El alta web y los dos checkouts (`season-pass-signup`,
 * `season-pass-checkout`, `pass-checkout`) montan el suyo aparte y no pasan por
 * aquí a propósito: allí el nivel no sale del abono sino del endpoint de
 * productos, que lo traduce a la versión vigente del mapa porque es el que
 * decide el precio.
 *
 * Este mismo texto es el que va en el pase de Google Wallet
 * (`GoogleWalletService::seatLabel`, que no pasa por aquí: cambiar el formato
 * obliga a cambiarlo también allí o el carné de la web dejará de decir lo mismo
 * que el del móvil). En el de Apple el nivel va en un campo aparte porque en la
 * cara del pase no cabe todo junto, pero dice lo mismo.
 *
 * Devuelve null si el abono no tiene butaca asignada (hay abonos sin butaca:
 * hasta que se les asigna una no se les puede ni cobrar). Si lo que falta es el
 * nivel —nivel de una versión del mapa ya purgada— se devuelve la fila y la
 * butaca solas, que es mejor que no decir nada.
 */
export function seasonPassSeatLabel(seasonPass: {
  row?: string | number | null;
  seat?: string | number | null;
  level?: { name?: string | null } | null;
} | null | undefined): string | null {
  if (!seasonPass?.seat) return null;

  const seat = `Fila ${seasonPass.row}, Butaca ${seasonPass.seat}`;
  const level = seasonPass.level?.name;

  return level ? `${level} · ${seat}` : seat;
}
